import { render, staticRenderFns } from "./UpdateUserExtensionModal.vue?vue&type=template&id=945a1236&"
import script from "./UpdateUserExtensionModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserExtensionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports